import { useState } from 'react';

export function useCreateWorkspaceDialog() {
  const [isCreateWorkspaceDialogOpen, setIsCreateWorkspaceOpen] =
    useState(false);

  const openCreateWorkspaceDialog = () => {
    setIsCreateWorkspaceOpen(true);
  };

  const closeCreateWorkspaceDialog = () => {
    setIsCreateWorkspaceOpen(false);
  };

  return {
    isCreateWorkspaceDialogOpen,
    openCreateWorkspaceDialog,
    closeCreateWorkspaceDialog,
  };
}
